import Axios from 'axios';
import i18next from 'i18next';

import {
	CLEAR_SELF_RULES_ERRORS,
	CLEAR_SELF_RULES_SINGLE_ERROR,
	SELF_RULE_CREATE_LOADING,
	SELF_RULE_CREATE_ERROR,
	ALL_SELF_RULES_LOADING,
	ALL_SELF_RULES_GET,
	ALL_SELF_RULES_ERROR,
	SELF_RULE_UPDATE_LOADING,
	SELF_RULE_UPDATE_ERROR,
	SELF_RULE_STATUS_HISTORY_LOADING,
	SELF_RULE_STATUS_HISTORY_GET,
	SELF_RULE_STATUS_HISTORY_ERROR,
	SELF_RULE_DELETE_LOADING
} from '../types';

// Utils
import create_query_params from '../../utils/create_query_params';
import add_key_prop from '../../utils/add_key_prop';

export const clear_self_rules_errors = (key) => dispatch => {
	if (key) {
		dispatch({
			type: CLEAR_SELF_RULES_SINGLE_ERROR,
			payload: key
		});
	}
	else {
		dispatch({
			type: CLEAR_SELF_RULES_ERRORS
		});
	}
}

export const self_rule_create = (messageApi, selfRuleBody, handleCancel, filters) => dispatch => {
	dispatch(clear_self_rules_errors('self_rule_update_not_modified'));

	dispatch({
		type: SELF_RULE_CREATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/self/rules/create';

	Axios.post(url, selfRuleBody)
	.then((res) => {
		messageApi.success(i18next.t('rulesForm.create.msg.success'), 4);

		handleCancel();

		dispatch({
			type: SELF_RULE_CREATE_LOADING,
			payload: false
		});

		dispatch(get_all_self_rules(filters));
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: SELF_RULE_CREATE_ERROR,
			payload: { type: 'self_rule_create', msg: err.message }
		});

		dispatch({
			type: SELF_RULE_CREATE_LOADING,
			payload: false
		});
	})
}

export const get_all_self_rules = (filters) => dispatch => {
	dispatch({
		type: ALL_SELF_RULES_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/self/rules?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		const newRulesArray = add_key_prop(res.data.data);
		// Sort by index
		newRulesArray.sort((a, b) => a.index - b.index);
		res.data.rules = newRulesArray;

		dispatch({
			type: ALL_SELF_RULES_GET,
			payload: res.data
		});

		dispatch({
			type: ALL_SELF_RULES_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_SELF_RULES_ERROR,
			payload: { type: 'all_self_rules', msg: err.message }
		});

		dispatch({
			type: ALL_SELF_RULES_LOADING,
			payload: false
		});
	})
}

export const self_rule_update = (messageApi, selfRuleId, selfRuleBody, handleCancel, filters) => dispatch => {
	dispatch(clear_self_rules_errors('self_rule_update_not_modified'));
	dispatch(clear_self_rules_errors('self_rule_update'));

	dispatch({
		type: SELF_RULE_UPDATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/rules/${selfRuleId}/update`;

	Axios.put(url, selfRuleBody)
	.then((res) => {
		if (res.status === 200) {
			messageApi.success(i18next.t('rulesForm.edit.msg.success'), 4);

			handleCancel();
	
			dispatch(get_all_self_rules(filters));
		}
		else if (res.status === 208) {
			dispatch({
				type: SELF_RULE_UPDATE_ERROR,
				payload: { type: 'self_rule_update_not_modified', msg: res?.data?.error }
			});
		}

		dispatch({
			type: SELF_RULE_UPDATE_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: SELF_RULE_UPDATE_ERROR,
			payload: { type: 'self_rule_update', msg: err.message }
		});

		dispatch({
			type: SELF_RULE_UPDATE_LOADING,
			payload: false
		});
	})
}

export const get_self_rule_status_history = (selfRuleId) => dispatch => {
	dispatch({
		type: SELF_RULE_STATUS_HISTORY_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/rules/${selfRuleId}/status/history`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: SELF_RULE_STATUS_HISTORY_GET,
			payload: res.data
		});

		dispatch({
			type: SELF_RULE_STATUS_HISTORY_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: SELF_RULE_STATUS_HISTORY_ERROR,
			payload: { type: 'get_self_rule_status_history', msg: err.message }
		});

		dispatch({
			type: SELF_RULE_STATUS_HISTORY_LOADING,
			payload: false
		});
	})
}

export const self_rule_status_update = (messageApi, selfRuleId, status, filters, closeStatusUpdateModal) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + `/api/self/rules/${selfRuleId}/status/update`;

	let statusBody = { status }

	Axios.put(url, statusBody)
	.then((res) => {
		// console.log(res.data)
		messageApi.success(i18next.t('statusUpdate.success'), 4);

		closeStatusUpdateModal();
		dispatch(get_all_self_rules(filters));
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('statusUpdate.error'), 4);
	})
}

export const self_rule_delete = (messageApi, selfRuleId, filters) => dispatch => {
	dispatch({
		type: SELF_RULE_DELETE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/rules/${selfRuleId}/remove`;

	Axios.delete(url)
	.then((res) => {
		messageApi.success(i18next.t('rulesForm.delete.msg.success'), 4);

		dispatch({
			type: SELF_RULE_DELETE_LOADING,
			payload: false
		});

		dispatch(get_all_self_rules(filters));
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('rulesForm.delete.msg.error'), 4);

		dispatch({
			type: SELF_RULE_DELETE_LOADING,
			payload: false
		});
	})
}
